




export default {
  head() {
    return {
      title: this.campusInfo?.attributes?.metaTitle ? `${this.campusInfo?.attributes?.metaTitle}` :  `${this.campusInfo?.attributes?.name}`,
      meta: this.campusInfo?.attributes?.meta != null && this.campusInfo?.attributes?.meta != undefined ?
        JSON.parse(this.campusInfo?.attributes?.meta.replace('\n', '')) : null 
    };
  },

  data() {
    return {
      videoStarted: false
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.videobackground) {
        this.$refs.videobackground.player.play()
        this.videoStarted = true
      }
    }, 3000);

    if (process.browser) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('inView');
          }
        });
      }, {
        threshold: 0
      });

      [...document.querySelectorAll('.animatable')].map(animatable => {
        observer.observe(animatable);
      })

    }

    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '-50% 0 0 0', // Set the rootMargin, you can use any valid CSS margin value
    };
    if (process.browser) {
      const observer = new IntersectionObserver((entries, options) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('inView');
          }
        });
      }, {
        threshold: 0.3
      });

      [...document.querySelectorAll('.animationBotomToTop')].map(animationBotomToTop => {
        observer.observe(animationBotomToTop);

      })

    }

  },


  async asyncData({ params, $http, store, redirect }) {
    // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
    // instances = instances.data;
    let instances = store.state.instances;

    // if (store.state.instance) {
    //   let instance = store.state.instance;
    //   console.log("test1");

    //   if (instance.attributes.subFolderName !== params.campusHP) {
    //     instance = instances.filter((instance) => {
    //       return instance.attributes.subFolderName == params.campusHP
    //     })[0];
    //   }
    // }


    const instance = instances.filter((instance) => {
      return instance.attributes.subFolderName == params.campusHP
    })[0];

    if(!instance){
      // redirect to lost page
      redirect('/404-error/')
    }

    // let instance = store.state.instance;

    if (!store.state.instance) {
      // const instance = instances.filter((instance) => {
      //   return instance.attributes.subFolderName == params.campusHP
      // })[0];

      store.commit('setInstance', instance)
    }

    // let campusInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-home-page?populate=
    // videoDeFond,
    // banniere,banniereLogo,banniereTexe,plusCampusLogo, nomCollone1, nomCollone2, nomCollone3, 
    // avantageCampusLogo1,avantageCampusLogo2,avantageCampusLogo3,avantageCampusTexteGros1,avantageCampusTextePetit1,
    // avantageCampusTexteGros2,avantageCampusTextePetit2,avantageCampusTexteGros3,avantageCampusTextePetit3,tousNosCentresImage,
    // detailCampusImage,detailCampusTexteGros,detailCampusTextePetit`);
    // campusInfo = campusInfo.data;

    let campusInfo = store.state.campusInfo;

    let backgroundUrl = process.env.strapiBaseUri + campusInfo.attributes.banniere?.data?.attributes?.url;
    let banniereLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.banniereLogo?.data?.attributes?.url;
    let plusCampusLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.plusCampusLogo?.data?.attributes?.url;


    let campusDiplomas = JSON.parse(JSON.stringify(store.state.campusDiplomas));

      // let allDiplomas = JSON.parse(JSON.stringify(store.state.diplomas));
      // let campusDiplomas = [];
      // if (allDiplomas.length == 0) {
      //   campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-diplomas`);
      //   campusDiplomas = campusDiplomas.data;
      //   // store.commit('setDiplomas', JSON.parse(JSON.stringify(allDiplomas)))
      // }
      // else {
      //   campusDiplomas = allDiplomas.filter((allDiplomas) => {
      //     return allDiplomas.campus == instance?.attributes.prefix
      //   });
      // }

      // let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-diplomas`);
      // campusDiplomas = campusDiplomas.data;
      
      let collone1Diplomas = campusDiplomas.filter((diploma) => {
        return diploma.attributes.collone === 'Collone_1';
      })
      collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
        return d1.attributes.ordre - d2.attributes.ordre
      })
      let collone2Diplomas = campusDiplomas.filter((diploma) => {
        return diploma.attributes.collone === 'Collone_2';
      })
      collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
        return d1.attributes.ordre - d2.attributes.ordre
      })
      let collone3Diplomas = campusDiplomas.filter((diploma) => {
        return diploma.attributes.collone === 'Collone_3';
      })
      collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
        return d1.attributes.ordre - d2.attributes.ordre
      })


      let yourDate = new Date();
      yourDate = yourDate.toISOString().split('T')[0];
      let jposInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-jpos?filters[dateJPO][$gte]=${yourDate}&filters[dateDebutAff][$lte]=${yourDate}`);
      jposInfo = jposInfo.data;

      let avantageCampusLogo1Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo1?.data?.attributes?.url;
      let avantageCampusLogo2Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo2?.data?.attributes?.url;
      let avantageCampusLogo3Url = process.env.strapiBaseUri + campusInfo.attributes.avantageCampusLogo3?.data?.attributes?.url;
      let tousNosCentresImageUrl = process.env.strapiBaseUri + campusInfo.attributes.tousNosCentresImage?.data?.attributes?.url;
      let detailCampusImageUrl = process.env.strapiBaseUri + campusInfo.attributes.detailCampusImage?.data?.attributes?.url;
      let videoDeFondUrl = process.env.strapiBaseUri + campusInfo.attributes.videoDeFond?.data?.attributes?.url;

      return {
        instances, instance, campusInfo,
        videoDeFondUrl, collone1Diplomas, collone2Diplomas,
        collone3Diplomas, jposInfo, backgroundUrl, banniereLogoUrl, plusCampusLogoUrl,
        avantageCampusLogo1Url, avantageCampusLogo2Url, avantageCampusLogo3Url,
        tousNosCentresImageUrl, detailCampusImageUrl
      }
    },
  }
